/**
 * Keys used as argument of postProcess in i18n to give format to the translated word
 */
export enum PostProcessKeys {
  TitleCase = 'titlecase',
  Capitalize = 'capitalize',
}
